import styled, { css } from 'styled-components';
import { Modal as AntdModal } from 'antd';
import { rgba } from 'polished';

export const Modal = styled(AntdModal)`
  ${({ theme }) => css`
    .ant-modal-content {
      border-radius: 8px;
      background-color: ${theme.colors.neutralSilver5};
    }

    .ant-modal-body {
      padding: 40px;

      @media (max-width: 992px) {
        padding: 24px 14px;
      }
    }

    .ant-modal-close {
      top: 40px;
      right: 24px;

      @media (max-width: 992px) {
        top: 24px;
        right: 16px;
      }
    }

    .ant-modal-close-x {
      width: 44px;
      height: 44px;

      @media (max-width: 992px) {
        width: 48px;
        height: 48px;
      }
    }
  `}
`;

export const CloseButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 0;
    margin: 0;
    background-color: ${rgba(theme.colors.neutralSilver10, 0.25)};
    cursor: pointer;

    @media (max-width: 992px) {
      width: 48px;
      height: 48px;

      svg {
        width: 24px;
        height: 24px;
      }
    }
  `}
`;

export const Content = styled.div`
  margin-top: 40px;
  @media (max-width: 768px) {
    margin-top: 24px;
  }

  svg {
    vertical-align: baseline;
  }
`;

export const Tabs = styled.div`
  @media (max-width: 350px) {
    margin-top: 56px;
  }
`;

export const InfoMessageContainer = styled.div`
  margin-top: 14px;
`;
